import { render, staticRenderFns } from "./EyeExamCard.vue?vue&type=template&id=a021d6dc"
import script from "./EyeExamCard.vue?vue&type=script&lang=js"
export * from "./EyeExamCard.vue?vue&type=script&lang=js"
import style0 from "./EyeExamCard.vue?vue&type=style&index=0&id=a021d6dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports